import CloseIcon from '@mui/icons-material/Close';
import { Controller, useForm } from 'react-hook-form';
import Modal from 'react-modal';
import { IEmailTemplateContactInputModel } from 'inputModels';
import { useState } from 'react';
import { sendContactEmail } from '../../../controller/EmailController';
import { BasicButton } from '../../Buttons/BasicButton';
import { Container } from './styles';
import { useAlert } from '../../../hooks/useAlert';
import { useApp, useAuth } from '../../../context';
import { useConfig } from '../../../context/configCustom';
import { EmailOutlined } from '@mui/icons-material';

interface ModalContactUsProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

export function ModalContactUs({ isOpen, onRequestClose }: ModalContactUsProps) {
  const { pathResourceEmail } = useConfig();
  const { user } = useAuth();
  const alert = useAlert();
  const app = useApp();
  const [defaultValue] = useState({ message: '' });
  const {
    control,
    watch,
    reset,
    setError,
    formState: { errors },
  } = useForm({ defaultValues: defaultValue });
  const data = watch();

  const handleSendContact = () => {
    if (!pathResourceEmail) {
      alert.show({ message: 'Erro ao enviar sua mensagem', type: 'error' });
      return;
    }
    if (!data.message) {
      setError('message', { message: 'Sua menssagem é obrigatória' });
      return;
    }
    app.setLoading(true);
    const input: IEmailTemplateContactInputModel = {
      message: data.message,
      userName: `${user.firstName} ${user.lastName}`,
      userEmail: user.email,
      pathResource: pathResourceEmail,
    };
    sendContactEmail(input)
      .then(() => {
        alert.show({
          message: 'Contato enviada com sucesso! Em breve retornaremos via email',
          type: 'success',
        });
        onRequestClose();
        reset();
      })
      .catch(() => {
        alert.show({ message: 'Erro ao enviar sua mensagem', type: 'error' });
      })
      .finally(() => {
        app.setLoading(false);
      });
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="contactUsModal-overlay"
      className="contactUsModal-content">
      <Container>
        <div className="headerModal">
          <p>
            <EmailOutlined /> Fale conosco
          </p>
          <div className="close-div">
            <button type="button" onClick={onRequestClose}>
              <CloseIcon fontSize="small" />
            </button>
          </div>
        </div>

        <div className="contentModal">
          <div className="containerNote">
            <Controller
              control={control}
              name="message"
              render={({ field }) => (
                <textarea
                  {...field}
                  className="note"
                  onChangeCapture={() => {
                    setError('message', { message: '' });
                  }}
                  maxLength={150}
                  placeholder="Tem algo a nos dizer? Envie sua dúvida, sugestão ou comentário."
                />
              )}
            />
            {errors.message && <span className="fieldError">{errors.message.message}</span>}
          </div>
          <div className="buttonModal">
            <BasicButton variant="outlined" size="medium" onClick={onRequestClose}>
              Cancelar
            </BasicButton>
            <BasicButton
              variant="outlined"
              disabled={!data.message}
              size="medium"
              onClick={handleSendContact}>
              Enviar
            </BasicButton>
          </div>
        </div>
      </Container>
    </Modal>
  );
}
